// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1rDuw","header":"Messages_header__3MFqI"};